import { Component, type ErrorInfo, type ReactNode } from 'react';

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
  onReset?: () => void;
}

interface State {
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('[island] uncaught error:', error, info.componentStack);
  }

  handleRetry = () => {
    this.setState({ error: null });
    this.props.onReset?.();
  };

  render() {
    if (this.state.error) {
      if (this.props.fallback) return this.props.fallback;
      return (
        <div className="mx-auto max-w-md py-16 text-center" role="alert">
          <p className="mb-2 text-sm text-secondary">Something went wrong</p>
          <button
            type="button"
            onClick={this.handleRetry}
            className="btn-primary min-h-[44px] px-4"
          >
            Retry
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
